module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zyu10m/tc-custom/9781452127286.jpg?1700253328470",
      "alt": "This image is the cover for the book But I Wanted a Pony!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("But I Wanted a Pony!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This collection of vintage-with-a-twist artwork offers a fresh serving of hilarious commentary on the joys, challenges, and cocktail hours of motherhood. ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From the fundamentals (WOW! I get to give birth AND change diapers!) to putting food on the table (you see them as pies . . . I see them as cries for help) to dealing with childhood questions (because I’m the mother . . . that’s why) and strategies for taking the edge off (now be a dear and fetch mommy her flask), Taintor expertly captures the funny, frantic, and honest thoughts that most moms have experienced, with an attitude mothers everywhere will welcome. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anne Taintor\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0